var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.classButton + 'svg-edit-container',on:{"click":function($event){return _vm.action()}}},[_c('span',{staticClass:"tooltip"},[_vm._t("default")],2),_c('img',{staticStyle:{"cursor":"pointer"},attrs:{"src":_vm.imgUrl,"alt":"urlImage","width":"40"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }